/**
 * Service for Category funcs..
 */

(function () {
    'use strict';

    angular.module('itxApp.common').service('BundleSvc', BundleSvc);

    BundleSvc.$inject = [
        '$q',
        'ItxUtilsFct',
        'Product',
        'ItxShopCartFct',
        'ProductRelatedSvc',
        'ItxConfigurationSvc',
        'ItxTranslateSvc'
    ];

    function BundleSvc(
        $q,
        ItxUtilsFct,
        Product,
        ItxShopCartFct,
        ProductRelatedSvc,
        ItxConfigurationSvc,
        ItxTranslateSvc
    ) {
        var COMING_SOON = joyr.constants.visibility.COMMING_SOON_VISIBILITY;
        var BACK_SOON = joyr.constants.visibility.BACK_SOON_VISIBILITY;
        var SHOW = joyr.constants.visibility.SHOW_VISIBILITY;

        var service = {
            parseBundleProducts: _parseBundleProducts,
            addItemsToCart: _addItemsToCart,
            parseBundle: _parseBundle
        };
        return service;

        function _addItemsToCart(bundleProducts) {
            var deferred = $q.defer();
            var productsAdded = [];

            _.map(bundleProducts, function (p) {
                if (
                    p.bundleProductSelected.checked &&
                    p.state.selectedSize &&
                    p.state.selectedSize.visibility === SHOW
                ) {
                    p.bundleProductSelected.checked = false;
                    productsAdded = _.concat(productsAdded, p);
                }
            });

            if (productsAdded.length > 0) {
                var products = productsAdded.map((p) => {
                    return ItxShopCartFct.generateCartItem(
                        p,
                        p.activeDetail.colors[p.state.selectedColorIndex],
                        p.state.selectedSize
                    );
                });
                ItxShopCartFct.addMultipleProductsToCart(products, productsAdded).then(function () {
                    deferred.resolve(productsAdded);
                });
            } else {
                deferred.reject();
            }
            return deferred.promise;
        }

        function _parseBundleProducts(bundle) {
            var deferred = $q.defer();
            var visibleProducts = _filterVisibilityProducts(bundle.bundleProductSummaries);

            /** TODO - MDECOMM-26703
             * Si es un bundle de mocacos estos son filtrados y no tienen visibilidad
             * la funcion stockSizes se encarga de revisar si tienen stock
             **/
            if (visibleProducts.length === 0) {
                visibleProducts = bundle.bundleProductSummaries;
            }

            var promiseBundleProducts = _.map(visibleProducts, function (product) {
                product.bundleProductSelected = { checked: false };
                return new Product(product).fetch();
            });

            $q.all(promiseBundleProducts).then(function (products) {
                products = _getProductsImagesSiluet(products);
                products = _checkStockSizes(products);
                deferred.resolve(products);
            });

            return deferred.promise;
        }

        function _parseBundle(bundle) {
            var deferred = $q.defer();
            service.parseBundleProducts(bundle).then(function (products) {
                bundle.bundleProducts = products;
                bundle.viewDetail = false;
                bundle.productUrl = bundle.getUrl();
                deferred.resolve(bundle);
            });
            return deferred.promise;
        }

        function _getProductsImagesSiluet(products) {
            return _.filter(products, function (p) {
                var imageItem = ItxUtilsFct.getImageProductUrls(
                    p.activeDetail,
                    p.state.selectedColor.id,
                    'relatedProduct',
                    'siluet2',
                    'grid'
                );
                if (imageItem && imageItem[0]) {
                    // p.state.bundleSiluet = imageItem[0].replace('_5_', '_4_'); FONDO GRIS
                    p.state.bundleSiluet = imageItem[0];
                } else {
                    console.error(
                        'EL PRODUCTO - ' +
                            p.id +
                            ' - No tiene imagen de "relatedProduct" "siluet2" "grid" y no se muestra en el Bundle'
                    );
                }
                return p.state.bundleSiluet;
            });
        }

        function _checkStockSizes(products) {
            var textBackSoon = ItxTranslateSvc.translateCms('legacy.Product.stock.back_soon');
            var textComingSoon = ItxTranslateSvc.translateCms('legacy.Product.stock.coming_soon');
            return _.filter(products, function (p) {
                var stockItem = false;

                // TODO CLass Product Si es talla única set selectedSize
                if (
                    p.state.selectedColor.sizes.length === 1 &&
                    p.state.selectedColor.sizes[0].name === '01'
                ) {
                    p.state.selectedSize = p.state.selectedColor.sizes[0];
                }

                _.map(p.activeDetail.colors[p.state.selectedColorIndex].sizes, function (s) {
                    switch (s.visibility) {
                        case SHOW:
                            // si tenemos una talla disponible no filtramos el producto
                            stockItem = true;
                            s.nameSizeBundle = s.name;
                            break;

                        case COMING_SOON:
                            stockItem = true;
                            s.nameSizeBundle = s.name + ' - ' + textComingSoon;
                            break;

                        case BACK_SOON:
                            stockItem = true;
                            s.nameSizeBundle = s.name + ' - ' + textBackSoon;
                            break;
                    }
                });
                return stockItem;
            });
        }

        function _filterVisibilityProducts(products) {
            return _.filter(products, function (p) {
                return (
                    p.visibility === SHOW ||
                    p.visibility === COMING_SOON ||
                    p.visibility === BACK_SOON
                );
            });
        }
    }
})();
